<template lang="pug">
  div(v-if="isShow")
    v-card
      v-card-title.pa-2(:class="headerClass")
        span.white--text {{$t('list.item.estimate_and_order_no')}} {{row.id}}
        v-spacer
        v-chip(v-if="!search.enabled" small disabled outline color="white")
          v-avatar
            v-icon location_on
          span {{item.token}}
        v-chip(v-if="search.enabled" small disabled :color="search.color")
          v-avatar
            v-icon info
          span {{search.status}}
      v-card-text
        .app-line
          span.app-line-title {{$t('list.item.order_date')}}
          span.app-line-text {{item.prepare.order_date|date}}
          span.app-line-suffix
        .app-line(v-if="!arranged && !completed")
          span.app-line-title {{$t('list.item.input_date')}}
          span.app-line-text {{item.summary.input_date|date}}
          span.app-line-suffix
        .app-line(v-if="arranged || completed")
          span.app-line-title.warning--text 出荷日
          span.app-line-text.warning--text {{item.summary.delivery_date|date}}
          span.app-line-suffix
        .app-line
          span.app-line-title {{$t('list.item.seller')}}
          span.app-line-text
            span(v-if="item.summary.seller") {{item.summary.seller.options.sign}}
          span.app-line-suffix
        .app-line
          span.app-line-title {{$t('list.item.inputter')}}
          span.app-line-text
            span(v-if="item.summary.inputter") {{item.summary.inputter.options.sign}}
          span.app-line-suffix
        .app-line
          span.app-line-title {{$t('list.item.customer')}}
          span.app-line-text
            span(v-if="item.summary.customer") {{item.summary.customer.display}}
          span.app-line-suffix {{$t('list.item.honorific')}}
        .app-line
          span.app-line-title {{$t('list.item.total_rows')}}
          span.app-line-text {{item.total_rows|number}}
          span.app-line-suffix {{$t('list.item.rows')}}
        .app-line
          span.app-line-title {{$t('list.item.total_boxes')}}
          span.app-line-text {{item.total_boxes|number}}
          span.app-line-suffix {{$t('list.item.pcs')}}
        .app-line
          span.app-line-title {{$t('list.item.delivery_fee')}}
          span.app-line-text {{item.summary.delivery_fee|number}}
          span.app-line-suffix {{$t('list.item.currency_unit')}}
        .app-line
          span.app-line-title 値引
          span.app-line-text {{discountDisplayValue|number}}
          span.app-line-suffix 円
        .app-line
          span.app-line-title {{$t('list.item.grand_total')}}
          span.app-line-text {{item.grand_total|number}}
          span.app-line-suffix {{$t('list.item.currency_unit')}}
        v-layout(row wrap)
          v-flex(xs4 md3 lg2 v-for="(box, boxIndex) in item.boxes" :key="boxIndex")
            v-card(flat)
              v-card-text.pa-0
                estimated-box(v-if="estimated" :token="token" :box-index="boxIndex")
                settled-box(v-if="settled" :token="token" :box-index="boxIndex")
                arranged-box(v-if="arranged" :token="token" :box-index="boxIndex")
                completed-box(v-if="completed" :token="token" :box-index="boxIndex")
        v-alert(type="warning" color="accent" value="true" v-if="!row.accepted" key="orderStatus")
          | 見積依頼を処理してください。
        v-alert(type="warning" value="true" v-else-if="!isFixed" key="orderStatus")
          | 注文入力が未確定です。
      v-card-actions
        v-layout(row wrap)
          v-flex(xs12)
            v-btn(flat color="primary" @click.stop="download('request', item.entry_quotation.filepath)" v-if="item.entry_quotation")
              v-icon(left) fa-file-pdf-o
              span 見積依頼書
            v-btn(flat color="primary" @click.stop="download('quotation', q.filepath)" v-for="(q, index) in latestQuotations" :key="index")
              v-icon(left) fa-file-pdf-o
              span 見積書
            v-btn(flat color="primary" @click.stop="download('instruction', item.instruction.filepath)" v-if="(arranged || completed) && item.instruction")
              v-icon(left) fa-file-pdf-o
              span 作業指示書
          v-flex(xs12)
            v-tooltip(bottom)
              v-btn(fab flat color="warning" @click.stop="jumpToOrder" slot="activator" v-if="!row.settled && !requested")
                v-icon fa-pencil
              span 修正
            v-tooltip(bottom)
              v-btn(fab flat color="pink darken-1" @click.stop="dialog.settle.open = true" slot="activator" v-if="estimated && isFixed")
                v-icon fa-check
                v-dialog(lazy v-model="dialog.settle.delay" width="440" v-if="dialog.settle.open")
                  v-card
                    v-card-title.pa-2.pink.darken-1
                      span.white--text 確定
                      v-spacer
                      v-btn(flat small icon @click.stop="dialog.settle.open = false")
                        v-icon.white--text close
                    v-card-text
                      v-alert(type="success" color="pink darken-1" value="true")
                        | 見積/注文番号 No.{{row.id}} を確定します。よろしいですか？
                    v-card-actions
                      v-spacer
                      v-btn(flat color="pink darken-1" @click.stop="settle")
                        v-icon(left) fa-check
                        span 確定
              span 確定
            v-tooltip(bottom)
              v-btn(fab flat color="deep-purple darken-1" @click.stop="dialog.arrange.open = true" slot="activator" v-if="settled")
                v-icon fa-check
                v-dialog(lazy v-model="dialog.arrange.delay" width="440" v-if="dialog.arrange.open")
                  v-card
                    v-card-title.pa-2.deep-purple.darken-1
                      span.white--text 調整完了
                      v-spacer
                      v-btn(flat small icon @click.stop="dialog.arrange.open = false")
                        v-icon.white--text close
                    v-card-text
                      v-alert(type="success" color="deep-purple darken-1" value="true")
                        | 見積/注文番号 No.{{row.id}} の調整を完了します。よろしいですか？

                      v-menu(
                        lazy
                        :close-on-content-click="false"
                        v-model="deliveryDatePicker"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        )
                        v-text-field(
                          label="出荷日"
                          hint="出荷日を指定してください。初期値は１ヶ月後です。"
                          persistent-hint
                          slot="activator"
                          :value="deliveryDate|date"
                          prepend-icon="schedule"
                          ref="delivery_date"
                          :rules="[rules.required,rules.date]"
                          readonly
                          )
                        v-date-picker(
                          v-model="deliveryDate"
                          )

                    v-card-actions
                      v-spacer
                      v-btn(flat color="deep-purple darken-1" @click.stop="arrange")
                        v-icon(left) fa-check
                        span 調整完了
              span 調整完了
            v-tooltip(bottom)
              v-btn(fab flat color="warning" @click.stop="dialog.copy.open = true" slot="activator" v-if="isFixed && !requested")
                v-icon fa-copy
                v-dialog(v-model="dialog.copy.delay" width="400" v-if="dialog.copy.open")
                  v-card
                    v-card-title.pa-2.warning
                      span.white--text 複写
                      v-spacer
                      v-btn(flat small icon @click.stop="dialog.copy.open = false")
                        v-icon.white--text close
                    v-card-text
                      v-menu(
                        lazy
                        :close-on-content-click="false"
                        v-model="newOrderDatePicker"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-right="40"
                        max-width="290px"
                        min-width="290px"
                        )
                        v-text-field(
                          label="基準日"
                          hint="複写時に適用する基準日を入力してください。"
                          slot="activator"
                          color="warning"
                          :value="newOrderDate|date"
                          prepend-icon="schedule"
                          ref="new_order_date"
                          :rules="[rules.required,rules.date]"
                          readonly
                          )
                        v-date-picker(
                          v-model="newOrderDate"
                          color="warning"
                          )
                      v-alert(type="warning" value="true")
                        | 見積/注文番号 No.{{row.id}} を複写します。よろしいですか？
                    v-card-actions
                      v-spacer
                      v-btn(flat color="warning" @click.stop="copyOrder")
                        v-icon(left) fa-copy
                        span 複写
              span 複写
            v-tooltip(bottom)
              v-btn.grey--text(fab flat @click.stop="dialog.remove.open = true" slot="activator" v-if="!row.settled && !requested")
                v-icon fa-remove
                v-dialog(v-model="dialog.remove.delay" width="440" v-if="dialog.remove.open")
                  v-card
                    v-card-title.pa-2.error
                      span.white--text 削除
                      v-spacer
                      v-btn(flat small icon @click.stop="dialog.remove.open = false")
                        v-icon.white--text close
                    v-card-text
                      v-alert(type="error" value="true")
                        | 見積/注文番号 No.{{row.id}} を削除します。よろしいですか？
                    v-card-actions
                      v-spacer
                      v-btn(flat color="error" @click.stop="removeOrder")
                        v-icon(left) fa-remove
                        span 削除
              span 削除
            v-btn(
              :flat="!row.isOutput"
              :raised="row.isOutput"
              :color="row.isOutput ? 'success' : 'grey'"
              :class="row.isOutput ? 'white--text' : 'grey--text'"
              @click="setOutput({token: token, isOutput: !row.isOutput})"
              v-if="!search.enabled && (arranged || completed)"
              )
              v-icon fa-check
              span CSV出力対象
</template>

<script>
import _ from 'underscore'
import EstimatedBox from './EstimatedBox'
import SettledBox from './SettledBox'
import ArrangedBox from './ArrangedBox'
import CompletedBox from './CompletedBox'
import { mapGetters, mapActions } from 'vuex'
import token from '@/common/services/token'
import rules from '@/common/mixins/rules'

export default {
  name: 'list-item',
  props: [
    'token',
    'requested',
    'estimated',
    'settled',
    'arranged',
    'completed',
    'search'
  ],
  components: {
    EstimatedBox,
    SettledBox,
    ArrangedBox,
    CompletedBox
  },
  mixins: [rules],
  data () {
    return {
      row: null,
      item: null,
      dialog: {
        settle: {
          open: false,
          delay: false
        },
        arrange: {
          open: false,
          delay: false
        },
        copy: {
          open: false,
          delay: false
        },
        remove: {
          open: false,
          delay: false
        }
      },
      newOrderDate: this.$moment().format('YYYY-MM-DD'),
      newOrderDatePicker: false,
      deliveryDate: this.$moment()
        .add(30, 'days')
        .format('YYYY-MM-DD'),
      deliveryDatePicker: false
    }
  },
  created () {
    this.row = this.getOrder(this.token)
    this.item = this.row.json
  },
  watch: {
    'dialog.settle.open': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.settle.delay = v
      }, 30)
    },
    'dialog.settle.delay': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.settle.open = v
      }, 30)
    },
    'dialog.arrange.open': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.arrange.delay = v
      }, 30)
    },
    'dialog.arrange.delay': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.arrange.open = v
      }, 30)
    },
    'dialog.copy.open': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.copy.delay = v
      }, 30)
    },
    'dialog.copy.delay': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.copy.open = v
      }, 30)
    },
    'dialog.remove.open': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.remove.delay = v
      }, 30)
    },
    'dialog.remove.delay': function (v) {
      let self = this
      setTimeout(function () {
        self.dialog.remove.open = v
      }, 30)
    }
  },
  computed: {
    ...mapGetters('app/list', ['getOrder']),
    isShow () {
      if (this.requested) {
        return !this.row.estimated
      }
      if (this.estimated) {
        return !this.row.settled
      }
      if (this.settled) {
        return this.row.settled && !this.row.arranged
      }
      if (this.arranged) {
        return this.row.arranged && !this.row.completed
      }
      if (this.completed) {
        return this.row.completed
      }
      return false
    },
    headerClass () {
      // 出力対象として選択された
      if ((this.arranged || this.completed) && this.row.isOutput) {
        return 'success'
      }
      // 見積依頼・受入待ち
      if (!this.row.accepted && this.estimated) {
        return 'accent'
      }
      // 確定している
      if (this.isFixed) {
        return 'primary'
      }
      return 'grey'
    },
    isFixed () {
      return this.item.grand_total >= 0
    },
    latestQuotations () {
      return _.filter(this.item.quotations, function (q) {
        return !q.outdated
      })
    },
    discountDisplayValue () {
      return parseInt(this.item.summary.discount, 10) * -1
    }
  },
  methods: {
    ...mapActions('app/list', ['hideOrder', 'addOrder', 'setOutput']),
    jumpToOrder () {
      this.$router.push({
        name: 'order_edit',
        params: { token: this.item.token }
      })
    },
    accept () {
      let self = this
      self.$ajax
        .post(`order/accept/${self.item.token}`)
        .then(function (response) {
          self.hideOrder(self.token)
        })
    },
    settle () {
      let self = this
      self.$ajax
        .post(`order/settle/${self.item.token}`)
        .then(function (response) {
          self.hideOrder(self.token)
        })
    },
    arrange () {
      let self = this
      if (self.hasRuleError()) {
        self.$toastr.warning(self.$t('_rules.invalidate_message'))
        return true
      }
      self.$ajax
        .post(`order/arrange/${self.item.token}`, {
          delivery_date: self.deliveryDate
        })
        .then(function (response) {
          self.hideOrder(self.token)
        })
    },
    download (type, filepath) {
      let self = this
      let encoded = encodeURIComponent(filepath)
      let v = window.open()
      self.$ajax
        .get(`order/presigned_${type}?q=${encoded}`)
        .then(function (response) {
          let uri = response.data.uri
          v.location.href = uri
        })
    },
    copyOrder () {
      let self = this
      if (self.hasRuleError()) {
        self.$toastr.warning(self.$t('_rules.invalidate_message'))
        return true
      }
      let params = {
        from_token: self.row.token,
        new_order_date: self.newOrderDate,
        new_token: token.publishToken()
      }
      self.$ajax.post('order/copy', params).then(function (response) {
        self.addOrder(response.data.order)
        self.dialog.copy.open = false
      })
    },
    removeOrder () {
      let self = this
      self.$ajax
        .post(`order/remove/${self.item.token}`)
        .then(function (response) {
          self.hideOrder(self.token)
          self.dialog.remove.open = false
        })
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/pages/List/Components/ListItem.vue